import React, {Fragment, useEffect, useState} from "react";
import {getParams, getSelectedOption} from "../../utils/hooks/getParams";

import {useDispatch, useSelector} from "react-redux";
import Select from "react-select";
import {getFirmOptions} from "../../actions/user";
import {getClientOptions} from "../../actions/sale";

const FilterByClient = (props) => {

    const dispatch = useDispatch();
    const {getPageItems, is_filter = false} = props;
    const {
        client_options
    } = useSelector(state => state.sale);

    useEffect(() => {
        dispatch(getClientOptions());
    }, [])

    const [currentClient, setCurrentFirm] = useState(Number(getParams().client_id) || '');
    const [isFirst, setIsFirst] = useState(true);

    useEffect(() => {
        const params = getParams();
        if (!isFirst) {
            if (is_filter) {
                dispatch(getPageItems({firm_id: currentClient, without_relationship: true}))
            } else {
                dispatch(getPageItems(1, params))
            }
        }
    }, [currentClient])

    useEffect(() => {
        setIsFirst(false);
    }, [])


    const [clientItems, setClientItems] = useState([
        {
            label: 'Tanlang',
            value: ''
        }
    ]);
    const handleSelect = (data, type) => {
        setCurrentFirm(data.value);
        if (data.value != '') {
            const params = getParams();
            params.client_id = data.value;
            const url = new URL(window.location);
            url.searchParams.set('page', 1);
            url.searchParams.set('client_id', data.value);
            window.history.pushState({}, '', url);
        } else {
            const url = new URL(window.location);
            url.searchParams.delete('client_id');
            window.history.pushState({}, '', url);
        }
    };
    useEffect(() => {
        if (client_options.length > 0) {
            let items = [
                {
                    label: 'Tanlang',
                    value: ''
                }
            ];
            client_options.map(item => items.push({
                label: item?.name,
                value: item?.id
            }))
            setClientItems(items);
        }
    }, [client_options])
    return (
        <Fragment>

            <Select styles={customStyles}
                    value={getSelectedOption(currentClient, clientItems)}
                    options={clientItems}
                    onChange={handleSelect}
                    menuPortalTarget={document.body}
                    menuPosition={'fixed'}
            />

        </Fragment>
    )
}
const customStyles = {
    ///.....
    menuPortal: provided => ({...provided, zIndex: 9999}),
    menu: provided => ({...provided, zIndex: 9999})
    ///.....
}
export default FilterByClient;